import { gql } from "@apollo/client";

export const SELECT_COURSE = gql`
  query SelectCourse {
    selectCourse {
      _id
      khName
      enName
    }
  }
`;

export const SELECT_USER = gql`
  query SelectUser($role: UserRole) {
    selectUser(role: $role) {
      _id
      familyName
      userName
    }
  }
`;

export const SELECT_SUBJECT = gql`
  query SelectSubject {
    selectSubject {
      _id
      khName
      enName
      remark
    }
  }
`;

export const SELECT_PERFORMANCE_TYPE = gql`
  query SelectPerformanceType {
    selectPerformanceType {
      _id
      khName
      enName
      date
    }
  }
`;

export const SELECT_SUBJECT_BY_CLASS_ID = gql`
  query SelectSubjectByClassId($classId: ID!) {
    selectSubjectByClassId(classId: $classId) {
      _id
      khName
      enName
      remark
    }
  }
`;

export const SELECT_CLASS = gql`
  query SelectClass {
    selectClass {
      _id
      className
      courseId {
        khName
        enName
        _id
      }
    }
  }
`;

export const SELECT_CLASS_BY_STUDENT_ID = gql`
  query GetClassByStudentId($studentId: ID) {
    getClassByStudentId(studentId: $studentId) {
      _id
      className
      courseId {
        enName
        khName
        _id
      }
    }
  }
`;

export const SELECT_EXAM_TYPE = gql`
  query SelectExamType($classId: ID) {
    selectExamType(classId: $classId) {
      _id
      examName
    }
  }
`;

export const SELECT_GROUP_FEE = gql`
  query SelectGroupFee {
    selectGroupFee {
      _id
      type
      title
      price
      remark
    }
  }
`;

export const SELECT_BOOK_GROUP_FEE = gql`
  query SelectBookGroupFee {
    selectBookGroupFee {
      _id
      type
      title
      price
    }
  }
`;

export const SELECT_STUDENT = gql`
  query SelectStudent($studentType: String) {
    selectStudent(studentType: $studentType) {
      _id
      profile
      familyName
      studentName
    }
  }
`;

export const SELECT_ENROLLMENT_BY_STUDENT = gql`
  query SelectEnrollmentByStudent($studentId: ID) {
    selectEnrollmentByStudent(studentId: $studentId) {
      _id
      classId {
        _id
        className
        courseId {
          khName
          enName
          _id
        }
      }
      payAs
      studentId {
        _id
        studentName
        familyName
        profile
      }
    }
  }
`;

export const SELECT_SCHEDULE_BY_CLASS = gql`
  query SelectScheduleByClass($classId: ID) {
    selectScheduleByClass(classId: $classId) {
      _id
      day
      startTime
      endTime
    }
  }
`;

export const SELECT_STUDENT_BY_CLASS = gql`
  query GetStudentByClassForSelect($classId: String) {
    getStudentByClassForSelect(classId: $classId) {
      _id
      familyName
      studentName
    }
  }
`;

export const SELECT_CONTENT = gql`
  query SelectContent($classId: String) {
    selectContent(classId: $classId) {
      _id
      classId {
        _id
        className
        courseId {
          _id
          khName
          enName
          totalHour
          remark
        }
      }
      title
    }
  }
`;

export const SELECT_LESSON = gql`
  query SelectLesson($classId: String) {
    selectLesson(classId: $classId) {
      _id
      title
      numbering
      description
      videoLink
      image
    }
  }
`;

export const SELECT_PACKAGE_PRICE = gql`
  query SelectPackagePrice($classId: String) {
    selectPackagePrice(classId: $classId) {
      _id
      title
      unlimited
      classId {
        _id
        className
        courseId {
          _id
          enName
          khName
          remark
          totalHour
        }
        duration
        isComplete
        totalHour
        totalLesson
        totalStudent
      }
      groupFeeId {
        _id
        type
        title
        price
        remark
      }
      duration
      discountType
      discountAmount
    }
  }
`;

export const SELECT_ONLINE_CLASS = gql`
  query SelectOnlineClass {
    selectOnlineClass {
      _id
      className
      courseId {
        _id
        khName
        enName
        totalHour
        remark
      }
    }
  }
`;

export const SELECT_ONLINE_CLASS_PACKAGE = gql`
  query SelectOnlineClassForPackagePrice {
    selectOnlineClassForPackagePrice {
      _id
      className
      courseId {
        _id
        khName
        enName
        totalHour
        remark
      }
    }
  }
`;

export const SELECT_CLASS_GROUP_FEE = gql`
  query SelectClassGroupFee {
    selectClassGroupFee {
      _id
      type
      title
      price
      remark
    }
  }
`;
